<template>
  <div class="landing">
    <div class="header__top">
      <div class="container">
        <nav class="menu">
          <a href="#header" class="menu__brand">
            <img src="../assets/otk_logo.png" alt="Логотип ОТК">
          </a>
          <ul class="menu__list">
            <li class="menu__item header active-link">
              <a class="menu__link" href="#header">Главная</a>
            </li>
            <li class="menu__item about">
              <a class="menu__link" href="#about">О нас</a>
            </li>
            <li class="menu__item advantages">
              <a class="menu__link" href="#advantages">Преимущества</a>
            </li>
            <li class="menu__item contacts">
              <a class="menu__link" href="#contacts">Контакты</a>
            </li>
            <li class="menu__item logout" v-if="loggedIn">
              <router-link class="menu__link" :to="{ name: 'logout' }" title="Выход"><i class="material-icons">logout</i></router-link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <section id="header">
      <div class="container">
        <div class="header__inner">
          <div class="header__content">
						<span class="hero__eyebrow" v-if="!loggedIn">ТОО «Ойл Транспорт Корпорейшэн»</span>
            <h1 v-if="!loggedIn">Автоматизированная система согласования актов выполненных работ и услуг</h1>
            <p class="hero__subtitle" v-if="!loggedIn">Создавайте, согласовывайте и контролируйте акты выполненных работ и услуг в едином защищённом цифровом пространстве.</p>
            <!-- <h2 v-if="loggedIn" style="font-weight: normal; margin-bottom: 3rem">Добро пожаловать, <strong>{{ user_full_name }}</strong>! <a href="/logout" class="custom-link"><i class='bx bx-exit'></i></a></h2> -->
            <div class="hero__art" v-if="!loggedIn">
              <img src="../assets/notebook.png" alt="Интерфейс системы AVR+">
            </div>
<!--            <img src="../assets/logo-white.png" style="position: fixed; top: -20px; left: 0; width: 100px; z-index: 10"  v-if="loggedIn">-->
            <a href="/login">
              <button v-if="!loggedIn" class="landing__btn landing__btn--primary">Вход | Регистрация</button>
            </a>
          </div>
          <div class="entry-point-inner" v-if="loggedIn">
            <div class="quick-menu-item">
              <img src="../assets/contracts.svg" alt="">
              <router-link class="landing__btn" :to="{ name: 'contracts' }">Договоры</router-link>
            </div>
            <div class="quick-menu-item">
              <img src="../assets/acts.svg" alt="">
              <router-link class="landing__btn" :to="{ name: 'acts' }">Акты</router-link>
            </div>
            <div class="quick-menu-item">
              <img src="../assets/notifications.svg" alt="">
              <router-link class="landing__btn" :to="{ name: 'notifications' }">Уведомления</router-link>
            </div>
            <div class="quick-menu-item">
              <img src="../assets/undraw_profile_details_re_ch9r.svg" alt="">
              <router-link class="landing__btn" :to="{ name: 'profile' }">Профиль</router-link>
            </div>
            <div class="quick-menu-item">
              <img src="../assets/undraw_texting_re_l11n.svg" alt="">
              <router-link class="landing__btn" :to="{ name: 'messenger' }">Чат</router-link>
<!--              <router-link class="landing__btn" :to="{ name: 'messages' }">Чат</router-link>-->
            </div>
            <div class="quick-menu-item">
              <img src="../assets/undraw_teaching_re_g7e3.svg" alt="">
              <!-- <router-link class="landing__btn" :to="{ name: 'tutorial' }">Обучение</router-link> -->
              <router-link class="landing__btn" :to="{ name: 'tutorial' }">Обучение</router-link>
            </div>
            <div class="quick-menu-item">
              <img src="../assets/undraw_questions_re_1fy7.svg" alt="">
              <router-link class="landing__btn" :to="{ name: 'learning' }">F A Q</router-link>
            </div>
            <div class="quick-menu-item">
              <img src="../assets/undraw_things_to_say_re_jpcg.svg" alt="">
              <!-- <router-link class="landing__btn" :to="{ name: 'developmentpage' }">Предложения</router-link> -->
              <router-link class="landing__btn" :to="{ name: 'offers' }">Предложения</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="about">
      <div class="container">
<!--        <h2 class="section-title">Коротко о нас</h2>-->
        <div class="about__inner">
          <div class="information">
            <h2 class="section-heading text-center">О системе согласования актов выполненных работ и услуг AVR+</h2>
            <p class="section-text text-center">
              Система <strong>AVR+</strong> предназначена для согласования актов выполненных работ и услуг ТОО «Ойл Транспорт Корпорейшэн»
            </p>
          </div>
<!--          <div class="illustration">-->
<!--            <img src="../assets/about.svg" alt="">-->
<!--          </div>-->
        </div>
      </div>
    </section>

    <section id="advantages">
      <div class="container">
        <h2 class="section-title">Преимущества</h2>
        <div class="advantages__inner">
          <div class="feature-grid">
            <div class="feature-card">
              <div class="feature-card__icon"><i class="bx bx-fast-forward"></i></div>
              <h3 class="feature-card__title">Быстрое обучение</h3>
              <p class="feature-card__text">Полностью автоматизированный процесс внедрения системы. Конфигурация предоставляется в готовом виде и не требует адаптации, настройки или дополнительных трудозатрат.</p>
            </div>
            <div class="feature-card">
              <div class="feature-card__icon"><i class="bx bx-git-compare"></i></div>
              <h3 class="feature-card__title">Выбор способа согласования</h3>
              <p class="feature-card__text">Выбирайте удобный способ согласования прямо на этапе создания акта.</p>
            </div>
            <div class="feature-card">
              <div class="feature-card__icon"><i class="bx bx-filter-alt"></i></div>
              <h3 class="feature-card__title">Фильтрация информации</h3>
              <p class="feature-card__text">Получайте только ту информацию, которая касается непосредственно Вас.</p>
            </div>
            <div class="feature-card">
              <div class="feature-card__icon"><i class="bx bx-user-check"></i></div>
              <h3 class="feature-card__title">Верификация аккаунтов</h3>
              <p class="feature-card__text">Регистрация производится в строго закрытом режиме с проверкой каждого аккаунта.</p>
            </div>
            <div class="feature-card">
              <div class="feature-card__icon"><i class="bx bx-bell"></i></div>
              <h3 class="feature-card__title">Уведомление о событиях</h3>
              <p class="feature-card__text">Получайте email-уведомления о ходе согласования данных прямо на почту.</p>
            </div>
            <div class="feature-card">
              <div class="feature-card__icon"><i class="bx bx-check-shield"></i></div>
              <h3 class="feature-card__title">Защита согласованных актов</h3>
              <p class="feature-card__text">Будьте уверены: согласованный акт не может быть изменён посторонними лицами.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="contacts">
      <div class="container">
<h2 class="section-title">Контакты</h2>
        <div class="contacts__inner">
          <div class="contacts__grid">
            <div class="contacts__item">
              <div class="contacts__label">Ответственный сотрудник ТОО «Ойл Транспорт Корпорейшэн»</div>
              <div class="contacts__content">
                <span class="contacts__name"><i class='bx bx-user'></i> Темиркасов Шапагат</span>
                <span><i class='bx bx-phone'></i> <a href="tel:87017008191" class="custom-link">8 701 700 81 91</a></span>
                <span><i class='bx bx-envelope'></i> <a href="mailto:Info_otc@otc.kmg.kz" class="custom-link">Info_otc@otc.kmg.kz</a></span>
              </div>
            </div>
            <div class="contacts__item">
              <div class="contacts__label">Техническая поддержка</div>
              <div class="contacts__content">
                <span class="contacts__name"><i class='bx bx-user'></i> Мағзұм Дархан Әлімжанұлы</span>
                <span><i class='bx bx-phone'></i> <a href="tel:87074927144" class="custom-link">8 707 492 71 44</a></span>
                <span><i class='bx bx-envelope'></i> <a href="mailto:support-avr@prodev.kz" class="custom-link">support-avr@prodev.kz</a></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <modal name="info-modal" height="400">
      <div class="modal-inner">
        <h3>Уважаемые пользователи!</h3>
        <div>
          <p>Уведомляем Вас, что начиная с <b>17 сентября 2025 года</b> доступ к системе AVR+ будет осуществляться через обновлённый адрес:
            <a href="https://avr.otk.kz"><b>https://avr.otk.kz</b></a>
          <p>
          <p>Просим учесть данное изменение при дальнейшей работе в системе. </p>
          <p>Рекомендуем заранее сохранить новый адрес в «Избранное» Вашего браузера и использовать его для авторизации.<p>
          <p>В случае возникновения затруднений при переходе по новому адресу Вы можете обратиться в службу технической поддержки ИТ по внутреннему телефону или корпоративной почте.<p>
          <p>Благодарим за внимание и приносим извинения за возможные временные неудобства!</p>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: '',
      email: '',
      message: '',
      loggedIn: false,
      is_IMPL: false,
      is_ABP: false,
      is_APPROVER: false,
      is_RATIFICATOR: false,
      is_ECONOMIST: false,
      is_BOOKER: false,
      is_DZOADM: false,
      user_full_name: ""
    }
  },
  methods: {
    submitContactForm() {
      console.log(1234)
      console.log(this.name)
      console.log(this.email)
      console.log(this.message)

    },
    isIMPL() {
      return localStorage.getItem('roles').includes(1);
    },
    isABP() {
      return localStorage.getItem('roles').includes(2);
    },
    isAPPROVER() {
      return localStorage.getItem('roles').includes(3);
    },
    isRATIFICATOR() {
      return localStorage.getItem('roles').includes(4);
    },
    isECONOMIST() {
      return localStorage.getItem('roles').includes(5);
    },
    isBOOKER() {
      return localStorage.getItem('roles').includes(6)
    },
    isDZOADM() {
      return localStorage.getItem('roles').includes(7);
    },
    userFullName() {
      let user = JSON.parse(localStorage.getItem('user'));
      return user["last_name"] + ' ' + user["first_name"];
    },
  },
  mounted() {
    // this.$modal.show("info-modal");
		const sections = document.querySelectorAll('section')
		const navLi = document.querySelectorAll('nav ul li')
    const nav = document.querySelector('.menu')
		window.onscroll = () => {
			let current = ''

      if (scrollY >= 600) {
        nav.classList.add('nav-scrolled')
      } else {
        nav.classList.remove('nav-scrolled')
      }

			sections.forEach(section => {
				const sectionTop = section.offsetTop
				if (scrollY >= sectionTop - 60) {
					current = section.getAttribute('id')
				}
			})

			navLi.forEach(li => {
				li.classList.remove('active-link')
				if (li.classList.contains(current)) {
					li.classList.add('active-link')
				}
			})
		}
	},
  created() {
    this.is_IMPL = this.isIMPL();
    this.is_ABP = this.isABP();
    this.is_APPROVER = this.isAPPROVER();
    this.is_RATIFICATOR = this.isRATIFICATOR();
    this.is_ECONOMIST = this.isECONOMIST();
    this.is_BOOKER = this.isBOOKER();
    this.is_DZOADM = this.isDZOADM();
    this.loggedIn = this.is_IMPL || this.is_ABP || this.is_APPROVER || this.is_RATIFICATOR || this.is_ECONOMIST || this.is_BOOKER || this.is_DZOADM;
    this.user_full_name = this.userFullName();
  }
};
</script>

<style scoped>
*,
*::before,
*::after {
	box-sizing: border-box;
}

.contacts__info {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
}

.contacts__content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  gap: 1rem;
}

.landing {
  background: #e4e9f7;
}

.container {
	max-width: 1220px;
	margin: 0 auto;
	padding: 0 10px;
}

a {
	text-decoration: none;
	color: inherit;
}

button {
	border: none;
	background-color: transparent;
	cursor: pointer;
	color: inherit;
}

.header-block {
	background-color: #fff;
}

.header__inner {
	display: flex;
	flex-direction: column;
	justify-content: center;
  align-items: center;
  min-height: 95vh;
}

.header__top {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 1rem 0;
  position: sticky;
  z-index: 99;
  background: #e4e9f7;
  top: 0;
}

.input-field {
  width: 400px;
  padding-left: 10px;
  padding-right: 10px;
  outline: none;
  border-radius: 10px;
}

.menu.nav-scrolled {
  color: black;
}

.menu__list {
	display: flex;
  justify-content: center;
  gap: 5rem;
  list-style-type: none;
  margin-bottom: 0;
}

.menu__item {
	margin-right: 30px;
  padding: 5px;
}

.menu__item.active-link {
  color: #2191FB !important;
}

.menu__item.logout {

}

.menu__link {
	font-size: 18px;
	transition: color .3s;
}

.menu__link:hover {
	color: #2191FB;
}

.header__content {
  margin: 0 auto;
  text-align: center;
}

.landing__btn {
  font-size: 20px;
  width: 200px;
  border: 1px solid #2191FB;
  border-radius: 10px;
  padding: .5rem 2rem;
  color: #2191FB;
  transition: all .3s;
  box-shadow: 0 18px 13px -6px rgba(0, 0, 0,0.2);
  position: sticky;
  background: #e4e9f7;
  text-align: center;

  top: 100px !important;
}

.landing__btn:hover {
  color: #fff;
  background: #2191FB;
  box-shadow: 0 25px 18px -6px rgba(0, 0, 0,0.2);
}

.header__content img {
  margin-bottom: 2rem;
}

.header__content h1 {
  margin-bottom: 2rem;
}


#about {
  background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%), url("../assets/home_otk.png") center no-repeat;
  background-size: cover;
  background-attachment: fixed;
  height: 50vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  /* background-color: #DB5A42; */
  /* text-align: center; */
}

.section-title {
  padding-top: 5rem;
  text-align: center;
}

.about__inner {
	display: flex;
	justify-content: space-between;
  align-items: center;
  gap: 2rem;
  margin: 0 auto;
	/*min-height: 100vh;*/
}

.information {
  /*max-width: 800px;*/
}

.section-text {
  font-size: 20px;
}

.illustration img {
  /* width: 600px; */
}

.section-heading {
  margin-bottom: 2rem;
}


#advantages {
  /* background-color: #666666; */
}

.implementation {
  padding: 30px 0;
  text-align: center;
}

.implementation-block {
  width: 400px;
  height: 200px;
  cursor: pointer;
  position: relative;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-style: italic;
  font-family: cursive;
}

.implementation-block i {
  font-size: 60px;
  margin: 25px auto 20px auto;
}

.implementation-hover-text {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #2191FB;
  opacity: 0;
  transition: opacity 0.4s;
  border-radius: 10px;
}
.implementation-block:hover .implementation-hover-text {
  opacity: 1;
}

.implementation-hover-text span {
  display: table;
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 25px;
  font-size: 18px;
  color: white;
  font-style: normal;
  font-family: serif;
}

.implementation-title {
  text-align: center;
  color: #083d75;
  text-transform: uppercase;
  margin-bottom: 40px;
}
.implementation img {
  height: 60px;
  margin: 25px auto 20px auto;
  /* opacity: 0.6; */
}
.implementation-subtitle {
  font-size: 22px;
  margin-bottom: 55px;
}

.advantages__inner {
	display: flex;
	justify-content: space-between;
  align-items: center;
}

#contacts {
  background: linear-gradient(to bottom, #e4e9f7 0%, rgba(255, 255, 255, 0.9) 100%), url("../assets/logo-header.png") no-repeat;
  /*background-size: ;*/
  background-position-x: center;
  background-position-y: 90%;
  background-attachment: fixed;
  /*background-size: cover;*/
  /*background-attachment: fixed;*/
  /* background-color: #999999; */
}

.contacts__inner {
  padding-top: 1rem;
	display: flex;
	justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 1rem;
	min-height: 40vh;
  font-size: 20px;
  padding-bottom: 2rem;
}

.contacts__item {
  display: flex;
  justify-content: space-between;
  height: auto;
  width: 100%;
}

.contacts__inner form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 50%;
}

.contacts__inner form input,
.contacts__inner form textarea {
  border: 1px solid #666;
  padding: .5rem 1rem;
  width: 100%;
}

.contacts__inner form input:focus,
.contacts__inner form textarea:focus {
  border: 1px solid #2191FB;
  outline: 0;
}

/* Entry point */



.entry-point-inner {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  /* min-height: 100vh; */
}

.quick-menu-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  border-radius: 20px;
  /*position: relative;*/
  margin-bottom: 2rem;
}

.quick-menu-item img {
  /*max-width: 300px;*/
  max-height: 200px;
  min-height: 200px;
  z-index: 2;

}

/* ===================== Современный редизайн главной ===================== */
.landing {
  background: linear-gradient(180deg, #eef3fb 0%, #e7edf9 100%);
  font-family: 'Segoe UI', system-ui, -apple-system, 'Helvetica Neue', Arial, sans-serif;
  color: #1b2a4a;
}

/* Навигация */
.header__top {
  padding: .85rem 0;
  background: rgba(238, 243, 251, 0.85);
  backdrop-filter: saturate(180%) blur(10px);
  -webkit-backdrop-filter: saturate(180%) blur(10px);
  border-bottom: 1px solid rgba(33, 145, 251, 0.12);
}
.menu {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  transition: all .3s ease;
}
.menu__brand {
  display: flex;
  align-items: center;
  gap: .2rem;
  flex-shrink: 0;
}
.menu__brand img { height: 30px; width: auto; margin: 0; }
.menu__brand-text { font-size: 1.7rem; font-weight: 800; line-height: 1; color: #2191FB; }
.menu__list { gap: 2.25rem; margin: 0; padding: 0; align-items: center; }
.menu__item { margin: 0; padding: 0; position: relative; }
.menu__link { font-size: 1rem; font-weight: 600; color: #44557a; padding: .35rem 0; }
.menu__link:hover { color: #2191FB; }
.menu__item.active-link { color: #2191FB !important; }
.menu__item.active-link::after {
  content: "";
  position: absolute;
  left: 0; right: 0; bottom: -4px;
  height: 3px; border-radius: 3px;
  background: #2191FB;
}
.menu__item.logout .menu__link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px; height: 38px;
  border-radius: 50%;
  background: rgba(33,145,251,.1);
  color: #2191FB;
}
.menu__item.logout .menu__link:hover { background: #2191FB; color: #fff; }

/* Hero */
.header__inner { min-height: 92vh; gap: 1.2rem; }
.header__content {
  max-width: 880px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.4rem;
}
.hero__eyebrow {
  display: inline-block;
  padding: .4rem 1rem;
  border-radius: 999px;
  background: rgba(33,145,251,.12);
  color: #1769c4;
  font-weight: 600;
  font-size: .85rem;
  letter-spacing: .04em;
  text-transform: uppercase;
}
.header__content h1 {
  font-size: clamp(1.8rem, 4vw, 3rem);
  line-height: 1.15;
  font-weight: 800;
  margin: 0;
  color: #14233f;
  letter-spacing: -0.01em;
}
.hero__subtitle {
  font-size: 1.2rem;
  line-height: 1.6;
  color: #5b6b87;
  max-width: 640px;
  margin: 0;
}
.hero__art { width: 100%; max-width: 720px; margin-top: .5rem; }
.hero__art img {
  width: 100%; height: auto; margin: 0;
  filter: drop-shadow(0 30px 45px rgba(20, 45, 90, 0.18));
}

/* Кнопки */
.landing__btn {
  position: static;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.05rem;
  font-weight: 600;
  width: auto;
  min-width: 220px;
  border: 2px solid #2191FB;
  border-radius: 12px;
  padding: .75rem 2.25rem;
  color: #2191FB;
  background: #fff;
  box-shadow: 0 10px 22px -10px rgba(33,145,251,.5);
  transition: all .25s ease;
}
.landing__btn:hover {
  color: #fff;
  background: #2191FB;
  transform: translateY(-2px);
  box-shadow: 0 16px 28px -10px rgba(33,145,251,.6);
}
.landing__btn--primary {
  color: #fff;
  background: linear-gradient(135deg, #2aa0ff 0%, #1769c4 100%);
  border-color: transparent;
}
.landing__btn--primary:hover {
  background: linear-gradient(135deg, #1f93f5 0%, #135aab 100%);
  color: #fff;
}

/* Заголовки секций */
.section-title {
  text-align: center;
  font-size: clamp(1.6rem, 3vw, 2.25rem);
  font-weight: 800;
  color: #14233f;
  padding-top: 4.5rem;
  margin-bottom: 2.5rem;
  position: relative;
}
.section-title::after {
  content: "";
  display: block;
  width: 60px; height: 4px;
  border-radius: 4px;
  background: #2191FB;
  margin: .9rem auto 0;
}

/* О системе */
#about { height: auto; min-height: 58vh; padding: 4rem 0; }
.about__inner { justify-content: center; }
.information {
  background: rgba(255,255,255,.74);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(255,255,255,.6);
  border-radius: 22px;
  padding: 2.75rem 3rem;
  max-width: 880px;
  box-shadow: 0 24px 50px -20px rgba(20,45,90,.35);
}
.section-heading {
  font-size: clamp(1.5rem, 3vw, 2.1rem);
  font-weight: 800;
  color: #14233f;
  margin-bottom: 1.25rem;
}
.section-text { font-size: 1.3rem; line-height: 1.6; color: #43547a; margin: 0; }
.section-text strong { color: #2191FB; }

/* Преимущества */
#advantages { padding-bottom: 4.5rem; }
.advantages__inner { display: block; }
.feature-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  width: 100%;
}
.feature-card {
  background: #fff;
  border: 1px solid #eaf0fa;
  border-radius: 18px;
  padding: 2rem;
  text-align: left;
  box-shadow: 0 14px 30px -18px rgba(20,45,90,.35);
  transition: transform .25s ease, box-shadow .25s ease, border-color .25s ease;
}
.feature-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 26px 44px -20px rgba(20,45,90,.45);
  border-color: rgba(33,145,251,.4);
}
.feature-card__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 58px; height: 58px;
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(33,145,251,.15), rgba(108,99,255,.15));
  margin-bottom: 1.25rem;
}
.feature-card__icon i { font-size: 30px; color: #2191FB; }
.feature-card__title { font-size: 1.2rem; font-weight: 700; color: #14233f; margin: 0 0 .6rem; }
.feature-card__text { font-size: 1rem; line-height: 1.6; color: #5b6b87; margin: 0; }

/* Контакты */
#contacts { padding-bottom: 4.5rem; background-size: 300px; background-position-y: 94%; }
.contacts__inner { min-height: auto; padding-top: 0; }
.contacts__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.5rem;
  width: 100%;
  max-width: 920px;
  margin: 0 auto;
}
.contacts__item {
  display: block;
  background: #fff;
  border: 1px solid #eaf0fa;
  border-radius: 18px;
  padding: 2rem;
  box-shadow: 0 14px 30px -18px rgba(20,45,90,.35);
  transition: transform .25s ease, box-shadow .25s ease;
}
.contacts__item:hover {
  transform: translateY(-4px);
  box-shadow: 0 24px 40px -20px rgba(20,45,90,.45);
}
.contacts__label {
  font-size: 1.05rem;
  font-weight: 700;
  color: #2191FB;
  margin-bottom: 1.25rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #eef2f8;
}
.contacts__content { align-items: flex-start; gap: .75rem; font-size: 1.05rem; color: #43547a; }
.contacts__content span { display: inline-flex; align-items: center; gap: .6rem; }
.contacts__content i { color: #2191FB; font-size: 1.2rem; }
.contacts__name { font-weight: 700; color: #14233f; }
.custom-link { color: #1769c4; font-weight: 600; transition: color .2s; }
.custom-link:hover { color: #2191FB; text-decoration: underline; }

/* Быстрое меню (после входа) */
.entry-point-inner { gap: 1.5rem; }
.quick-menu-item {
  background: #fff;
  border: 1px solid #eaf0fa;
  border-radius: 20px;
  padding: 1.5rem 1rem 1.75rem;
  box-shadow: 0 14px 30px -18px rgba(20,45,90,.35);
  transition: transform .25s ease, box-shadow .25s ease;
}
.quick-menu-item:hover {
  transform: translateY(-6px);
  box-shadow: 0 26px 44px -20px rgba(20,45,90,.45);
}
.quick-menu-item img { max-height: 150px; min-height: 150px; object-fit: contain; }

/* Модальное окно */
.modal-inner { padding: 2rem; line-height: 1.6; }
.modal-inner h3 { font-weight: 800; color: #14233f; margin-bottom: 1rem; }

/* Адаптив */
@media (max-width: 900px) {
  .contacts__grid { grid-template-columns: 1fr; }
  .menu__list { gap: 1.25rem; }
}
@media (max-width: 700px) {
  .menu { flex-direction: column; gap: .75rem; }
  .menu__list { gap: 1rem; flex-wrap: wrap; justify-content: center; }
  .information { padding: 2rem 1.5rem; }
  .landing__btn { min-width: 180px; }
}

</style>
